import { Button, Modal, Typography } from '@evocolabs/orkaui'
import React, { useEffect, useState } from 'react'

import { Box } from '@mui/material'
import Close24 from '@evocolabs/icons/lib/Close24'
import Dialog from '@mui/material/Dialog'
import HearingTestResultV2 from '@/src/components/HearingScreening/HearingTestResultV2'
import Slide from '@mui/material/Slide'
import SpinningCircle from '@/src/components/SpinningCircle'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { useBackend } from '@/src/providers/BackendProvider'
import { useRouter } from 'next/router'

const getHearingLossLevel = (points) => {
  const value = Math.max(...points)
  if (value < 20) return 'Normal'
  if (value < 40) return 'Mild'
  if (value < 55) return 'Moderate'
  if (value < 70) return 'Moderately Severe'
  return 'Severe'
}
export async function getServerSideProps(context) {
  const { getHearingTestResult } = useBackend()
  const res = await getHearingTestResult()
  const data = res.data.results
  const testRes = data[data.length - 1].web_hearing_test_result
  const level = [getHearingLossLevel(testRes.left), getHearingLossLevel(testRes.right)]
  return { props: { data, level } }
}
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
export default function HearingTestEntrance() {
  const { getHearingTestResult, deleteHearingTestResult } = useBackend()
  const [data, setData] = useState({ unloaded: true })
  const [level, setLevel] = useState({})
  const [open, setOpen] = useState(false)
  const [confirmDelOpen, setConfirmDelOpen] = useState(false)
  const router = useRouter()

  const confirmDeletion = async () => {
    await deleteHearingTestResult()
    setConfirmDelOpen(false)
    getResult()
  }
  const getResult = async () => {
    setData({ unloaded: true })
    const res = await getHearingTestResult()
    const data = res.data.results
    if (data.length) {
      const testRes = data[0].web_hearing_test_result
      const level = [getHearingLossLevel(testRes.left), getHearingLossLevel(testRes.right)]
      setData(testRes)
      setLevel(level)
    } else {
      setData({ unloaded: false })
    }
  }
  const showResult = async () => {
    if (data.left || data.right) {
      setOpen(true)
    } else {
      getResult().then(() => {
        if (data.left || data.right) {
          setOpen(true)
        } else {
          router.push('/HearingScreening')
        }
      })
    }
  }
  useEffect(() => {
    getResult()
  }, [])
  if (data.unloaded) {
    return (
      <Box
        sx={{
          mb: '16px',
          borderRadius: '12px',
          p: { md: '40px', xs: '16px' },
          bgcolor: theme.palette.white.main
        }}
      >
        <SpinningCircle />
      </Box>
    )
  }
  return (
    <Box
      sx={{
        mb: '16px',
        borderRadius: '12px',
        p: { md: '40px', xs: '16px' },
        bgcolor: theme.palette.white.main
      }}
    >
      <Box display={'flex'} flexDirection={'column'} gap={1}>
        <Typography variant="T1">
          {data.left || data.right ? 'Hearing Screening Result' : 'Hearing Screening'}
        </Typography>
        {data.left || data.right ? (
          <>
            <Typography variant="body2" mb={2}>
              You can check your latest hearing screening results here. You can also{' '}
              <a href="/HearingScreening" style={{ color: theme.palette.primary[600], cursor: 'pointer' }}>
                <Typography variant="Link">do the screening</Typography>
              </a>{' '}
              again if you are not satisfied with last result. You can also{' '}
              <Typography variant="Link" color={theme.palette.primary[600]} onClick={() => setConfirmDelOpen(true)}>
                delete your hearing screening result
              </Typography>
              .
            </Typography>
            <Modal
              open={confirmDelOpen}
              title="Delete hearing screening result"
              onOk={() => confirmDeletion()}
              onCancel={() => setConfirmDelOpen(false)}
              content="Confirm deleting your hearing screening result?"
            />
          </>
        ) : (
          <Typography variant="body2" mb={2}>
            It seems you have not taken a hearing screening before, then you might be interested in our free hearing
            screening to learn more about your hearing health, which takes around 10 minutes only.
          </Typography>
        )}
      </Box>
      <Button
        size="large"
        loadable
        handleClick={showResult}
        variant={data.left || data.right ? 'secondary' : 'primary'}
      >
        {data.left || data.right ? 'See Result' : 'Screening Now'}
      </Button>
      <Dialog fullScreen open={open} onClose={() => setOpen(false)} TransitionComponent={Transition}>
        <Box
          style={{ position: 'absolute' }}
          sx={{
            top: { xs: '16px', md: '24px' },
            right: { xs: '16px', md: '24px' },
            cursor: 'pointer'
          }}
          onClick={() => setOpen(false)}
        >
          <Close24 />
        </Box>
        <HearingTestResultV2 testRes={data} level={level} />
      </Dialog>
    </Box>
  )
}
